var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 52,
    viewBox: "0 0 36 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6269 3.51085C26.1269 1.84418 8.0269 3.31085 3.6269 22.5109C1.2269 34.5109 6.29357 41.8442 9.1269 44.0109C9.1269 44.0109 11.127 46.0109 14.627 47.5109C18.127 49.0109 25.127 49.0109 25.127 49.0109",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.127 12.5109V29.0109M10.627 28.5109L20.127 27.5109L29.627 26.5109",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourWork);
export default __webpack_public_path__ + "static/media/hourWork.cfa32ee1932c9d540897bb3704cecc1c.svg";
export { ForwardRef as ReactComponent };